import React from "react";
import styles from "./UnexpectedErrorPage.module.scss";
import useUnexpectedErrorPage, { UnexpectedErrorPageProps } from "./useUnexpectedErrorPage";

export default function UnexpectedErrorPage(props: UnexpectedErrorPageProps) {
    const { state, handlers, utilities } = useUnexpectedErrorPage(props);
    const { t } = utilities;

    return (
        <div className={styles.page}>
            <div className={styles.content}>
                <div className={styles.illustration} aria-hidden="true">
                    <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M60 12 A48 48 0 1 1 20 72" stroke="#E5E5E5" strokeWidth="9" strokeLinecap="round" fill="none"/>
                        <circle cx="14" cy="80" r="5" fill="#E5E5E5" opacity="0.6"/>
                        <circle cx="104" cy="92" r="3.5" fill="#E84250" opacity="0.4"/>
                        <circle cx="110" cy="76" r="2.5" fill="#E5E5E5" opacity="0.5"/>
                        <path d="M66 30 L49 63 L63 63 L54 90 L75 55 L62 55 Z" fill="#E84250"/>
                    </svg>
                </div>

                <h1 className={styles.title}>{t("ERROR_UnexpectedTitle")}</h1>
                <p className={styles.message}>{t("ERROR_UnexpectedMessage")}</p>

                <div className={styles.actions}>
                    <button className="btn btn-primary" onClick={handlers.handleRefresh}>
                        {t("ERROR_UnexpectedRefresh")}
                    </button>
                    <button className="btn btn-outline-primary" onClick={handlers.handleGoHome}>
                        {t("ERROR_UnexpectedHome")}
                    </button>
                </div>

                <div className={styles.details}>
                    <button
                        className={styles.detailsToggle}
                        onClick={handlers.toggleDetails}
                        aria-expanded={state.showDetails}
                    >
                        {state.showDetails ? t("ERROR_HideDetails") : t("ERROR_ShowDetails")}
                    </button>

                    {state.showDetails && (
                        <div className={styles.detailsBody}>
                            <p className={styles.errorMessage}>{utilities.errorMessage}</p>
                            <pre className={styles.stackTrace}>{utilities.stackTrace}</pre>
                            {utilities.componentStack && (
                                <pre className={styles.stackTrace}>{utilities.componentStack}</pre>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
